module.exports = __webpack_public_path__ + "img/B2-1.bb304925.jpg";